import { OverrideToken } from 'antd/es/theme/interface';

import variables from '../UIConfigProvider.module.scss';

export const Table: OverrideToken['Table'] = {
  colorPrimary: variables.clrPalettePrimary,
  padding: 8,
};
